export default __webpack_public_path__ + "static/media/NIAS0420.34I-30312_-17515_0.6244bedb.jpg";